import React from "react";

export default function Infoiconsvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <g clip-path="url(#clip0_3107_9245)">
        <path
          d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
          stroke="#666666"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.5 8.33301H12.5104"
          stroke="#666666"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.458 12.5H12.4997V16.6667H13.5413"
          stroke="#666666"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3107_9245">
          <path
            d="M0 0H25V19.91C25 22.7211 22.7211 25 19.91 25H5.09C2.27887 25 0 22.7211 0 19.91V0Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
